import { render, staticRenderFns } from "./HeavyFundList.vue?vue&type=template&id=607671f6&scoped=true&"
import script from "./HeavyFundList.vue?vue&type=script&lang=js&"
export * from "./HeavyFundList.vue?vue&type=script&lang=js&"
import style0 from "./HeavyFundList.vue?vue&type=style&index=0&id=607671f6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.9.6_kq6vcxhoovkpo5ecbydii27d4a/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "607671f6",
  null
  
)

export default component.exports